import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api } from '@saucelabs/sl-module-invitation';

import * as types from './types';

export const saveTableOffset = createAction(types.UPDATE_OFFSET);
export const toggleInvitationSelection = createAction(types.TOGGLE_INVITATION_SELECTION);
export const toggleAllInvitationsSelection = createAction(types.TOGGLE_ALL_INVITATIONS_SELECTION);
export const clearInvitationSelection = createAction(types.CLEAR_INVITATION_SELECTION);
export const toggleLoading = createAction(types.TOGGLE_LOADING);
export const updateFilter = createAction(types.UPDATE_FILTER);

export const getInvitationList = createApiAction(
  types.INVITATION_LIST_GET,
  (payload) => api.getInvitations(payload),
);

export const renewInvitation = createApiAction(
  types.INVITATION_RENEW,
  (payload) => api.renewInvitation(payload),
);

export const revokeInvitation = createApiAction(
  types.INVITATION_REVOKE,
  (payload) => api.revokeInvitation(payload),
);
